module.exports = __webpack_public_path__ + "img/logo.466f74f9.png";